import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('phx-svg-icon')
export class PhoenixSvgIcon extends LitElement {
    appCacheBuster: string = window.appCacheBuster ?? '';
    static styles = css`
        svg {
            color: inherit;
            display: flex;
            fill: currentColor;
            height: inherit;
            vertical-align: text-top;
            width: inherit;
        }
    `;

    @property()
    icon: string | null = null;

    protected render() {
        return this.icon
            ? html`<svg>
                  <use href="/assets-global/icons/svg-sprite.svg?${this.appCacheBuster}#${this.icon}"></use>
              </svg>`
            : html``;
    }
}
